import { getTimestampSeconds } from './access-status.helper';

const DAY_ORDER = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

const formatTime = time => {
    if (!time || typeof time.hours !== 'number') return null;

    const date = new Date();
    date.setHours(time.hours, time.minutes || 0, 0, 0);

    return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
};

const formatDate = (seconds, now) => {
    const date = new Date(seconds * 1000);
    const sameYear = date.getFullYear() === now.getFullYear();

    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        ...(sameYear ? {} : { year: 'numeric' })
    });
};

const formatDays = days => {
    const selected = DAY_ORDER.filter(day => (days || []).includes(day));
    if (!selected.length || selected.length === DAY_ORDER.length) return null;

    return selected.map(day => day.charAt(0).toUpperCase() + day.slice(1)).join(' - ');
};

const formatHours = (start, end) => {
    if (start && end) return `${start} - ${end}`;
    if (start) return `From ${start}`;
    if (end) return `Until ${end}`;
    return null;
};

const formatDates = (beginSec, expireSec, now) => {
    const begins = beginSec ? formatDate(beginSec, now) : null;
    const expires = expireSec ? formatDate(expireSec, now) : null;

    if (begins && expires) return begins === expires ? begins : `${begins} - ${expires}`;
    if (begins) return beginSec > now.getTime() / 1000 ? `Starting ${begins}` : null;
    if (expires) return `Until ${expires}`;
    return null;
};

export const formatAccessWindow = (schedule, now = new Date()) => {
    const expireSec = getTimestampSeconds(schedule?.access_expires);
    if (expireSec && expireSec < now.getTime() / 1000) {
        return `Access Expired ${formatDate(expireSec, now)}`;
    }

    const days = formatDays(schedule?.access_days);
    const hours = formatHours(
        formatTime(schedule?.access_start_time),
        formatTime(schedule?.access_end_time)
    );
    const dates = formatDates(
        getTimestampSeconds(schedule?.access_begins),
        expireSec,
        now
    );

    let window;
    if (days && hours) window = `${days}, ${hours}`;
    else if (days) window = `Anytime ${days}`;
    else if (hours) window = `Daily ${hours}`;
    else window = 'Anytime Access';

    return dates ? `${window} · ${dates}` : window;
};

const formatDateTime = (seconds, now) => {
    const date = new Date(seconds * 1000);
    const sameYear = date.getFullYear() === now.getFullYear();

    return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        ...(sameYear ? {} : { year: 'numeric' }),
        hour: 'numeric',
        minute: '2-digit'
    });
};

export const formatCodeWindow = (code, now = new Date()) => {
    const startsSec = getTimestampSeconds(code?.starts_at);
    const expiresSec = getTimestampSeconds(code?.expires_at);

    const parts = [code?.reusable ? 'Reusable' : 'One-time Use'];

    const days = formatDays(code?.access_days);
    const hours = formatHours(
        formatTime(code?.access_start_time),
        formatTime(code?.access_end_time)
    );

    if (days && hours) parts.push(`${days}, ${hours}`);
    else if (days) parts.push(days);
    else if (hours) parts.push(`Daily ${hours}`);

    if (startsSec && startsSec > now.getTime() / 1000) {
        parts.push(`Code Starts ${formatDateTime(startsSec, now)}`);
    } else if (expiresSec) {
        parts.push(`Code Expires ${formatDateTime(expiresSec, now)}`);
    }

    return parts.join(' · ');
};
